import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

interface SuccessActionButtonProps {
  showStreamsButton: boolean;
  showWebPlayerButton: boolean;
  isChangeStreamFlow: boolean;
  close: () => void;
  onChangeStreamClick: () => void;
  onBindPointSuccessClick: () => void;
}

const SuccessActionButton: FC<SuccessActionButtonProps> = ({
  showStreamsButton,
  showWebPlayerButton,
  isChangeStreamFlow,
  close,
  onChangeStreamClick,
  onBindPointSuccessClick,
}) => {
  if (showStreamsButton) {
    return (
      <Button
        elementId="button_open_streams_success_modal"
        type={ButtonType.PRIMARY}
        onClick={onChangeStreamClick}>
        {TEXTS.MODAL_BIND_SUCCESS_BUTTON_OPEN_STREAMS_TEXT}
      </Button>
    );
  }

  if (showWebPlayerButton) {
    return (
      <Button
        elementId="button_open_web_player_bind_success_modal"
        type={ButtonType.PRIMARY}
        onClick={onBindPointSuccessClick}>
        {TEXTS.MODAL_BIND_SUCCESS_BUTTON_OPEN_WEB_PLAYER_TEXT}
      </Button>
    );
  }

  if (isChangeStreamFlow) {
    return (
      <Button
        elementId="button_change_device_success_modal"
        type={ButtonType.PRIMARY}
        onClick={() => close()}>
        {TEXTS.MODAL_BIND_SUCCESS_BUTTON_SUCCESS_TEXT}
      </Button>
    );
  }

  return (
    <Button
      elementId="button_open_points_bind_success_modal"
      type={ButtonType.PRIMARY}
      onClick={onBindPointSuccessClick}>
      {TEXTS.MODAL_BIND_SUCCESS_BUTTON_OPEN_POINTS_TEXT}
    </Button>
  );
};

export default memo(SuccessActionButton);
